// Unpublished Work © 2026 Deere & Company.

import {createUiAxiosClient} from 'Utils/ui-axios-client';

async function sendSMS(payload) {
    const axiosClient = createUiAxiosClient();

    const response = await axiosClient.post('/api/sms/send', payload);

    return response.data;
}

export {
    sendSMS
};
